import type { OnboardingStatus } from './accountContext';
import { useAccount } from './useAccount';

export type { OnboardingStatus } from './accountContext';

export interface OnboardingStatusResult {
  status: OnboardingStatus;
  refresh: () => void;
}

/**
 * Reads `profiles.onboarding_completed` via GET /api/v1/me/profile, served from
 * the shared `AccountProvider` cache.
 *
 * Fail-open behaviour is unchanged from the Week 1 gate: when the lookup itself
 * fails the status is `unknown` and protected routes let the user through.
 */
export function useOnboardingStatus(): OnboardingStatusResult {
  const { onboardingStatus, refresh } = useAccount();
  return { status: onboardingStatus, refresh };
}
